import * as STD      from '@emersya/mpa-std-lib';
import CM            from '@emersya/mpa-components-manager-lib';
import { MenuPanel } from '@emersya/mpa-components-lib';

export interface IStandingCustomerModeComponentConfiguration extends CM.Component.IConfiguration {
};

export class StandingCustomerModeComponent extends CM.Component<
	StandingCustomerModeComponent,
	IStandingCustomerModeComponentConfiguration
>
{
	async onAppReady() {
		if (app.parameters.mode === 'client') {
			const panel = <MenuPanel.Component> app.component_find('@.modules:panel');
			await panel.open('viewer-planner-floor-editor');
		}
	};

	override async component_start(startEvent : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(startEvent);
		if (app.parameters.mode === 'client') {
			if (!app.clientAppParameters.app.savedConfigurationCode && !app.clientAppParameters.app.savedBasket) {
				location.replace(STD.net.URL_changeAndFormat(location, (URL) => {
					delete URL.parameters.mode;
				}));
			}
			{
				const sheet = new CSSStyleSheet();
				sheet.insertRule(
					'[data-component-type].component-mpaengine-application > [data-component-id="modules"] .disabled.css-priority.disabledByCustomerMode { display : none !important; }');
				document.adoptedStyleSheets.push(sheet);
			}
		} else {
		}
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingCustomerModeComponentConfiguration
	)
	{
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = StandingCustomerModeComponent;
	export type Component = StandingCustomerModeComponent;
	export type Configuration = IStandingCustomerModeComponentConfiguration;
}

CM.declare({
	id :   'standing-customerMode',
	type : StandingCustomerModeComponent
});
